import { Injectable } from '@angular/core';
import { TranslatorService } from '@service/translator/translator.service';
import { LocalSettingsKey } from '@shared/types/local-settings';
import { ConfigsStorage } from '@storage/configs.storage';
import { SessionUtilsService } from './session-utils.service';
import { LoginService } from './login.service';
import { TranslateService } from '@ngx-translate/core';
import { NotificationService } from '@service/notification.service';
import { Router } from '@angular/router';
import { ProfilePhotoCacheService } from '../profile-photo/profile-photo-cache.service';
import { ImageDownloadLogsService } from '@service/utils/image-download-logs.service';

@Injectable({
  providedIn: 'root',
})
export class LogoutService {
  constructor(
    private router: Router,
    private notificationService: NotificationService,
    private translateService: TranslateService,
    private translatorService: TranslatorService,
    private configsStorage: ConfigsStorage,
    private profilePhotoCacheService: ProfilePhotoCacheService,
    private loginService: LoginService,
    private imageDownloadLogsService: ImageDownloadLogsService
  ) {}

  logout(): void {
    this.loginService.logout().subscribe(
      data => {
        this.clearAfterLogout();
      },
      error => {
        this.notificationService.showError(this.translateService.instant(error.error.message));
        this.router.navigate(['/m']);
      }
    );
  }

  clearAfterLogout(navigateHome = false): void {
    this.profilePhotoCacheService.clearPhotoCache();
    SessionUtilsService.clearLocalStorage(this.imageDownloadLogsService);
    this.translatorService.setLanguageAfterLogout();

    if (navigateHome || !this.configsStorage.isDssSuiteEnable()) {
      window.location.href = '/home';
    } else {
      this.router.navigate(['/login']);
    }

    if (!this.configsStorage.isDssSuiteEnable()) {
      localStorage.setItem(LocalSettingsKey.LOGGED_OUT, 'true'); // To sync the app for logout attempts
      localStorage.removeItem(LocalSettingsKey.LOGGED_OUT); // To sync the app for logout attempts
    }
  }
}
